<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "TableDataBatchUpdated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            return this.$t('notification.tableDataBatchUpdated', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                tableName: this.$_.get(this.activity, 'payload.tableName'),
                recordCount: this.$_.get(this.activity, 'payload.recordCount', 0),
                fieldName: this.$_.get(this.activity, 'payload.fieldName')
            });
        }
    }
};
</script>


